import axios from 'axios';
import { Cookies } from 'react-cookie';

import request from 'utils/http';
import Apis from 'constants/api';
import Icons from 'constants/icons';
import appConstants from 'constants/appConstants';

import { showError, showSuccess, showInfo, showWarning } from '../notifications/action';

const responseMessages = appConstants.responseMessages;

import actionType from './actionType';
import { startLoading, stopLoading } from 'service/loader/action';
import _get from 'lodash/get';


export const login = (payload) => dispatch => {
    dispatch(showInfo('Login Request Processing', Icons.tick));
    axios.post(Apis.user.login, payload).then(({ data: { data } }) => {
        dispatch(showSuccess(responseMessages.users.loginSuccess, Icons.thumbsUp));
        const { token } = data;
        localStorage.setItem('token', token);
        dispatch(showSuccess('Redirecting to Landing Screen', Icons.tick));
        request.redirectTo('/reference-data/dashboard');
    }).catch(({ response }) => {
        const error = _get(response.data, 'error', null);
        dispatch(showError(error.message, Icons.thumbsDown));
        dispatch({
            type: actionType.LOGIN_FAILURE,
        });
    });
};


export const logout = () => {
    localStorage.removeItem('token');
    request.post(Apis.user.logout).then(() => {
        request.redirectTo('/');
    });
};


export const getUserDetails = () => (dispatch) => {
    request.get(Apis.user.details).then(({ data: { data } }) => {
        dispatch({
            type: actionType.GET_USER_DETAILS_SUCCESS,
            payload: data,
        });
    }).catch(() => {
        dispatch({
            type: actionType.GET_USER_INFO_FAILURE,
        });
    });
};


export const getAllUsersData = (isLogs) => (dispatch) => {
    if (!isLogs) dispatch(startLoading());
    request
        .get(Apis.user.users)
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
            dispatch({
                type: actionType.GET_ALL_EN_USERS_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getAllUsersLogs = () => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.user.userLogs)
        .then(({ data }) => {
            console.log(data);
            dispatch(stopLoading());
            dispatch({
                type: actionType.GET_ALL_ACTIVITY_LOGS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const resetAllLogs = () => (dispatch) => {
    dispatch({
        type: actionType.GET_ALL_ACTIVITY_LOGS,
        payload: [],
    });
};


export const register = (payload) => dispatch => {
    request.post(Apis.user.registerUser, payload).then(({ data: { data } }) => {
        dispatch(showSuccess('User Registered Successfully', Icons.thumbsUp));
        dispatch(stopLoading());
        dispatch(getAllUsersData());
    }).catch(({ response }) => {
        const error = _get(response.data, 'error', null);
        if(error.message)
        dispatch(showError(error.message, Icons.thumbsDown));
        else
        dispatch(showWarning('Unable to create user'));        
    });
};

export const deleteUserById = (id) => (dispatch) => {
    dispatch(startLoading());
    request
        .delete(Apis.user.delete, {
            data: {
                id,
            },
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess('User Deleted Successfully', Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch(getAllUsersData());
        })
        .catch((error) => {
            dispatch(showWarning('Unable to Delete'));
            dispatch(stopLoading());
        });
};

export const updateUser = (payload = {}) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.user.userUpdate, {
            data: payload,
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess('User Updated Successfully', Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch(getAllUsersData());
        })
        .catch((error) => {
            dispatch(showWarning('Unable to Update User "Role Id does not exists" ', Icons.thumbsDown));
            dispatch(stopLoading());
        });
};

export const getAllRolesData = () => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.user.roles)
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
            dispatch({
                type: actionType.GET_ALL_EN_ROLES_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const addRole = (payload = {}) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.user.roles, {
            data: payload,
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess('Role Added Successfully', Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch(getAllRolesData());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Add Role `, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const deleteRoleById = (id) => (dispatch) => {
    dispatch(startLoading());
    request
        .delete(Apis.user.roles, {
            data: {
                id,
            },
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess('Role Deleted Successfully', Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch(getAllRolesData());
        })
        .catch((error) => {
            dispatch(showWarning('Unable to Delete'));
            dispatch(stopLoading());
        });
};

export const updateRole = (payload = {}) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.user.roleUpdate, {
            data: payload,
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess('Role Updated Successfully', Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch(getAllRolesData());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Update Role ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getAllApplicationConfiguration = (role_id) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.user.applications, { role_id })
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
            dispatch({
                type: actionType.GET_ALL_EN_APPLICATIONS_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getAllDashboardConfiguration = (id, roleId) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.user.dashboards, {
            application_id: id,
            role_id: roleId,
        })
        .then(({ data: { data } }) => {

            dispatch(stopLoading());
            dispatch({
                type: actionType.GET_ALL_EN_DASHBOARD_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const resetDashboardConfigurations = () => dispatch => {
    dispatch({
        type: actionType.GET_ALL_EN_DASHBOARD_SUCCESS,
        payload: [],
    });
};
export const resetDashboardRoutesConfigurations = () => dispatch => {
    dispatch({
        type: actionType.GET_ALL_EN_ROUTES_SUCCESS,
        payload: [],
    });
};
export const resetApplicationsConfigurations = () => dispatch => {
    dispatch({
        type: actionType.GET_ALL_EN_APPLICATIONS_SUCCESS,
        payload: [],
    });
};


export const getAllRoutesConfiguration = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.user.routes, payload)
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
            dispatch({
                type: actionType.GET_ALL_EN_ROUTES_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const setArray = (arr) => (dispatch) => {
    dispatch({
        type: actionType.SET_ARRAY_SUCCESS,
        payload: arr,
    });
};

export const captureOnChangeRoutePermissions = (payload) => (dispatch) => {
    dispatch({
        type: actionType.UPDATE_ONCHANGE_CAPTURE_ROUTE_PERMISSIONS,
        payload: payload,
    });
};

export const updateRoutes = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.user.authorization, payload)
        .then(() => {
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to update`));
            dispatch(stopLoading());
        });
};

export const getScreenPermissionsByRole = (pathName) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.user.screenPermissions, {
            params: {
                pathName,
            },
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionType.GET_APPLICATION_SCREEN_PERMISSION_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to update`));
            dispatch(stopLoading());
        });
};